import styled from "styled-components";
import { theme } from '../../theme'

export const SupportSectionContainer = styled.div`
    margin-top: 2.7rem;
`

export const SupportTicketCardWrapper = styled.div`
    background-color: ${theme.colors.mainWhite};
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0293252);
    border-radius: 1.1rem;
`
export const SupportTicketTopSection = styled.div`
    background-color: ${theme.colors.mainWhite};
    display: flex;
//   justify-content: space-around;
    align-items: center;
    padding: 1.9rem 3.7rem 1.9rem 1.2rem;
    border-bottom: 1px solid rgb(216 216 216 / 37%);
    border-radius: 1.1rem;
`
export const InputContainer = styled.div`
    @media only screen and (max-width: 500px) {
        display: none;
    }
}
`